<template>
	<div>
		<el-dialog title="学生住宿" width="1000px" :visible.sync="visible" :close-on-click-modal="false"
			@close="closeDialog">
			<div style="position:relative">
				<el-form v-if="formData" :model="formData" inline :rules="rules" ref="adminUserInfo"
					label-width="120px">
					<el-row :gutter="20">

						<el-col :span="12">

							<el-form-item label="准考证号" prop="exam_num" required>
								<el-input size="small" disabled type="text" v-model.trim="formData.exam_num"
									placeholder="准考证号" style="width: 100%" />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="身份证号" prop="identity_card" required>
								<el-input size="small" disabled type="text" v-model.trim="formData.identity_card"
									@change="getBirthdayFromIdCard" placeholder="身份证号" style="width: 100%" />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="学生姓名" prop="stu_name">
								<el-input size="small" disabled v-model.trim="formData.stu_name" style="width: 100%"
									placeholder="学生姓名" />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="联系方式" prop="phone">
								<el-input disabled size="small" v-model.trim="formData.phone" style="width: 100%"
									placeholder="手机号码" />
							</el-form-item>
						</el-col>
					</el-row>


					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="性别" prop="gender">
								<el-radio-group disabled size="small" v-model="formData.gender">
									<el-radio :label="1">男</el-radio>
									<el-radio :label="2">女</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="出生日期" prop="birthday">
								<el-date-picker disabled size="small" v-model="formData.birthday"
									value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:200px">
								</el-date-picker>
							</el-form-item>
						</el-col>

					</el-row>

					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="专业" prop="major_id">
								<el-input disabled placeholder="请选择专业" suffix-icon="el-icon-search"
									v-model="formData.major_name" size="small" style="width: 200px;">
								</el-input>

							</el-form-item>


						</el-col>
						<el-col :span="12">
							<el-form-item label="录取性质">
								<el-input disabled size="small" readonly="" v-model.trim="formData.nianzhi"
									style="width: 100%" placeholder="从专业中选择" />
							</el-form-item>
						</el-col>




					</el-row>





					<el-row :gutter="20">


						<el-col :span="12">
							<el-form-item label="户口详细地址" prop="jhr1name">
								<el-input size="small" v-model.trim="formData.pjson.huko_addr" style="width: 100%"
									placeholder="户口详细地址" />
								<div style="color:blue">距离学校：<span style="color:orangered">{{hukoDis}}</span>KM</div>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="家庭居住地址" prop="jhr1name">
								<el-input size="small" v-model.trim="formData.jtzz" style="width: 100%"
									placeholder="家庭居住地址" />
								<div style="color:blue">距离学校：<span style="color:orangered">{{jtzzDis}}</span>KM</div>
							</el-form-item>
						</el-col>

					</el-row>


					<el-row class="flexEnd" style="margin-top: 20px;">
						<el-input size="small" placeholder="审批不通过原因" v-model="spword"
							style="width:300px;margin-right:10px"></el-input>
						<el-button size="small" type="danger" @click="handleOk(2)">审批不通过</el-button>
						<el-button size="small" type="primary" @click="handleOk(1)">审批通过</el-button>
						<!-- <el-button size="small" type="primary" @click="handleOk('adminUserInfo')">保存并打印收费单</el-button> -->


					</el-row>

				</el-form>


			</div>

		</el-dialog>


	</div>
</template>
<script>
import api from '@/api/api';
export default {
	name: 'Form',
	components: {

	},
	data() {
		var checkmajor_id = (rule, value, callback) => {
			callback();
		};
		var validatorPhone = function (rule, value, callback) {
			if (value === '') {
				callback(new Error('手机号不能为空'))
			} else if (!/^1\d{10}$/.test(value)) {
				callback(new Error('手机号格式错误'))
			} else {
				callback()
			}
		};
		return {
			spword: "",
			visible: true,
			majorShow: false,
			formData: null,
			identity_type: "",
			rules: {


			},
			firstCascaderProps: {
				label: 'title',
				value: 'id',
				children: 'children',
				emitPath: false,
			},
			firstCascaderPropsArea: {
				label: 'label',
				value: 'value',
				children: 'children',
				emitPath: false,
				checkStrictly: true
			},
			schoolList: [],
			areaScore: {
				score_line: -1,
				plan_score: 0
			},
			loading: false,
			feeList: [],
			feeGroup: [],
			feeBz: "",
			identity_type: "身份证",
			minzuList: "汉族、蒙古族、回族、藏族、维吾尔族、苗族、彝族、壮族、布依族、朝鲜族、满族、侗族、瑶族、白族、土家族、哈尼族、哈萨克族、傣族、黎族、僳僳族、佤族、畲族、高山族、拉祜族、水族、东乡族、纳西族、景颇族、柯尔克孜族、土族、达斡尔族、仫佬族、羌族、布朗族、撒拉族、毛南族、仡佬族、锡伯族、阿昌族、普米族、塔吉克族、怒族、乌孜别克族、俄罗斯族、鄂温克族、德昂族、保安族、裕固族、京族、塔塔尔族、独龙族、鄂伦春族、赫哲族、门巴族、珞巴族、基诺族",
			teacherInfo: [],
			schlocation: { lng: 120.894473, lat: 31.420024 },
			jtzzDis:"--",
			hukoDis:"--"
		}
	},
	props: ["stuid"],
	mounted() {
		this.minzuList = this.minzuList.split("、")
		this.$http.post("/api/sch_student_one", { id: this.stuid }).then(res => {
			try {
				res.data.pjson = JSON.parse(res.data.pjson)
				if (!res.data.pjson.huko_addr) {
					res.data.pjson.huko_addr = ""
				}
			} catch (error) {

			}

			this.formData = res.data
			this.show()
			this.getAddressGps(this.formData.jtzz,e=>{
				this.jtzzDis = e
			})
			this.getAddressGps(this.formData.pjson.huko_addr,e=>{
				this.hukoDis = e
			})
			this.getInfo()
		})

	},
	methods: {
		getFlatternDistance(lat1, lng1, lat2, lng2) {
			if (lat1 == lat2 && lng1 == lng2) {
				return 0;
			}
			let EARTH_RADIUS = 6378136.49; //单位M
			let PI = Math.PI;

			let getRad = (d) => {
				return d * PI / 180.0;
			}
			let f = getRad((lat1 + lat2) / 2);
			let g = getRad((lat1 - lat2) / 2);
			let l = getRad((lng1 - lng2) / 2);

			let sg = Math.sin(g);
			let sl = Math.sin(l);
			let sf = Math.sin(f);

			let s, c, w, r, d, h1, h2;
			let a = EARTH_RADIUS;
			let fl = 1 / 298.257;

			sg = sg * sg;
			sl = sl * sl;
			sf = sf * sf;

			s = sg * (1 - sl) + (1 - sf) * sl;
			c = (1 - sg) * (1 - sl) + sf * sl;

			w = Math.atan(Math.sqrt(s / c));
			r = Math.sqrt(s * c) / w;
			d = 2 * w * a;
			h1 = (3 * r - 1) / 2 / c;
			h2 = (3 * r + 1) / 2 / s;

			return d * (1 + fl * (h1 * sf * (1 - sg) - h2 * (1 - sf) * sg));

		},
		getInfo(){
			this.$http.post("/api/t_sch_stu_dorm_spinfo",{stu_id:this.formData.id}).then(res=>{
				this.spword = res.data.sp_word
			})
		},
		showMajorWin() {

			this.majorShow = true

		},
		handleOk(st) {
			this.$http.post("/api/t_sch_stu_dorm_sp",{stu_id:this.formData.id,sp_word:this.spword,sp_status:st}).then(res=>{
				this.closeDialog()
				this.$$parent(this,"getList")
				this.$message.success("审批成功！")
			})
		},
		handleCancel() {
			// this.$emit('close')
			this.visible = false
		},
		closeDialog() {
			this.$parent.formshow = false
		},
		show() {
			// this.formData = Object.assign({}, this.editOptions)
			this.formData.nianzhi = this.formData.xuezhi
			this.areaScore.score_line = -1
			if (!this.formData.dorm) {
				this.formData.dorm = 0;
			}
			if (this.formData.hukou_code) {
				this.formData.hukou_code += '';
			}
			if (!this.formData.graduate_dist_code) {
				this.formData.graduate_dist_code = "320583"
				this.formData.graduate_sch_city = "江苏省,苏州市,昆山市"
			}
			if (this.formData.identity_card && this.formData.identity_card.length == 18) {
				this.identity_type = "身份证"
			} else if (this.formData.identity_card && this.formData.identity_card.length < 18) {
				this.identity_type = "港澳台居住证/护照"
			}

			this.visible = true



		},
		getAddressGps(addr,callback) {
			if (addr) {
				addr=addr.replace(",","")
				this.$http.post("/api/get_addres_gps", { addr: addr }).then(res => {
					if (res.data.result && res.data.result.location) {
						let dis = this.getFlatternDistance(this.schlocation.lat,this.schlocation.lng,res.data.result.location.lat,res.data.result.location.lng)
						if(dis>0){
							dis = parseInt(dis/100)/10
						}
						callback(dis)
					} else {
						this.$message.error(addr + "地址错误")
					}
				})
			}
		},
		handleCascaderChange(e) {
			console.log(1, e)
		},

		handleCascaderChangeArea(e) {
			let _this = this
			let node = this.$refs['firstCascader'].getCheckedNodes()[0]
			this.formData.graduate_sch_city = node.parent.parent.label + "," + node.parent.label + "," + node.label

			this.getSchoolList(e)

			this.getAreaScore(e)

		},
		handleCascaderChangeAreaHK(e) {
			let _this = this

			let node = this.$refs['hkCascader'].getCheckedNodes()[0]

			this.formData.hkszd = node.parent.parent.label + "," + node.parent.label + "," + node.label


		},
		getSchoolList(id) {
			return
			let _this = this
			this.$http.post(api.areaSchoolList, {
				dist_code: id
			}).then(res => {
				if (res.data && res.data.length > 0 && res.data[0].school_name != '') {
					this.schoolList = res.data
				} else {
					this.schoolList = []
				}
			})
		},
		changeSchool(e) {
			console.log(e)
			// let selectName = this.schoolList.find(obj => obj.id == e).graduate_schname
			this.formData.graduate_schname = e
			this.$forceUpdate()
		},
		searchSchool(e) {
			console.log(e)
			if (e) {
				this.formData.graduate_schname = e
				this.$http.post("/api/h5_schools", {
					school: e,
					onlymy: 1
				}).then(res => {

					this.schoolList = [{
						id: 0,
						graduate_schname: e
					}].concat(res.data.map((b, i) => {
						return {
							id: i + 1,
							graduate_schname: b.graduate_schname
						}
					}))
					//this.stuForm.graduate_schname = e
				})
			} else {
				this.schoolList = []
			}
		},
		getBirthdayFromIdCard: function () {
			let _this = this
			let birthday = "";
			let idCard = this.formData.identity_card
			if (idCard != null && idCard != "") {
				if (idCard.length == 15) {
					birthday = "19" + idCard.substr(6, 6);
					birthday = `${birthday.substr(0, 4)}-${birthday.substr(4, 2)}-${birthday.substr(6, 2)}`
					this.formData.birthday = birthday
				} else if (idCard.length == 18) {
					birthday = idCard.substr(6, 8);
					birthday = `${birthday.substr(0, 4)}-${birthday.substr(4, 2)}-${birthday.substr(6, 2)}`
					this.formData.birthday = birthday

					if (parseInt(idCard.substr(16, 1)) % 2 == 1) {
						//男
						this.formData.gender = 1
					} else {
						//女
						this.formData.gender = 2
					}


				}
				this.formData = {
					..._this.formData
				}
			}

		},
		getAreaScore(dist_code) {
			this.$http.post("/api/get_score_line", {
				dist_code: dist_code,
				major_id: this.formData.major_id
			}).then(res => {
				if (res.data) {
					this.areaScore = res.data
				}
			})
		},
		closeMajor(item) {

			this.majorShow = false
			if (item) {
				this.formData.major_id = item.id;
				this.formData.major_name = "(" + item.item_num + ")" + item.title;
				this.formData.nianzhi = item.item_desc
				this.formData.yuanxi = item.yuanxi
			} else {

				this.formData.yuanxi = this.formData.yuanxi_name || ''
			}
			//检查是否计算机系


			for (let k in this.feeGroup) {
				if (this.feeGroup[k].list.length > 1) {
					let isThisGroup = false;
					if (this.formData.yuanxi.indexOf("计算机") >= 0) {
						for (let item of this.feeGroup[k].list) {
							if (item.fee_name.indexOf("计算机") >= 0) {

								this.feeGroup[k].ckdid = item.id
								break;

							} else {
								this.feeGroup[k].ckdid = item.id
							}
						}
					} else { //不是计算机，则还原
						for (let item of this.feeGroup[k].list) {
							if (item.fee_name.indexOf("计算机") >= 0) {

							} else {
								this.feeGroup[k].ckdid = item.id
							}
						}
					}
				}
			}
		},
		setZhusu() {

			for (let item of this.feeList) {
				console.log(item)
				console.log(this.formData.dorm)
				if (this.formData.dorm && item.fee_name.indexOf("住宿") >= 0) {
					item.stu_fee = item.fee_name.split('￥')[1].replace(")", '')
					break
				} else if (!this.formData.dorm && item.fee_name.indexOf("住宿") >= 0) {
					item.stu_fee = 0

					break
				}
			}
			this.$nextTick(() => {
				this.$forceUpdate()
			})
		},
		getStudentFee(stu_id) {

			this.$http.post("/api/t_sch_cost_list", {
				stu_id: stu_id
			}).then(res => {
				let fee = [];
				if (res.data.stu) {

					res.data.stu.remark = JSON.parse(res.data.stu.remark)
					this.feeBz = res.data.stu.bz
				}

				let getStuFee = id => {
					let stu_fee = "";
					if (res.data.stu) {
						for (let item of res.data.stu.remark) {
							if (item.id == id) {
								stu_fee = item.stu_fee;
								break;
							}
						}
					}

					return stu_fee
				}

				for (let item of res.data.data) {

					if (item.fee_name.indexOf("住宿") >= 0) {
						fee.push({
							fee_name: item.fee_name + ":(￥" + item.fee_price + ")",
							fee_code: item.fee_code,
							fee_price: this.formData.dorm ? item.fee_price : 0,
							id: item.id,
							stu_fee: getStuFee(item.id)

						})
					} else {

						fee.push({
							fee_name: item.fee_name + ":(￥" + item.fee_price + ")",
							fee_code: item.fee_code,
							fee_price: item.fee_price,
							id: item.id,
							stu_fee: getStuFee(item.id)

						})
					}

				}
				this.feeList = fee
				//分组
				let group_obj = {};

				for (let item of fee) {

					if (item.fee_code) {
						if (!group_obj[item.fee_code]) {
							group_obj[item.fee_code] = {
								ckdid: item.id,
								list: [item]
							}
						} else {
							group_obj[item.fee_code].list.push(item)
							item.stu_fee > 0 ? group_obj[item.fee_code].ckdid = item.id : false
						}

					} else {
						group_obj[item.fee_name] = {
							ckdid: item.id,
							list: [item]
						}
					}
				}
				this.feeGroup = group_obj
				this.closeMajor()


			})
		},
		handleCommand(f) {
			let id = f.split("_")[0];
			let code = f.split("_")[1];
			for (let item of this.feeGroup[code].list) {
				this.feeGroup[code].ckdid = id
			}
		},
		autoWrite() {
			for (let item of this.feeList) {
				if (item.fee_name.indexOf("住宿") >= 0) {
					if (this.formData.dorm) {
						item.stu_fee = item.fee_name.split('￥')[1].replace(")", '')
					} else {
						item.stu_fee = 0;
					}
				} else {
					item.stu_fee = item.fee_name.split('￥')[1].replace(")", '')
				}

			}
		},
		saveStuFee() {

			//先检查费用是否都是数字
			for (let item of this.feeList) {

				if (isNaN(item.stu_fee)) {
					return -1

				}
			}


			let total_money = 0;
			let feeList = [];

			for (let k in this.feeGroup) {
				let fee = this.feeGroup[k]
				for (let item of fee.list) {
					item.stu_fee ? true : item.stu_fee = 0;
					if (fee.ckdid != item.id) {
						item.stu_fee = 0;
					}
					total_money += parseFloat(item.stu_fee);
					feeList.push(item)
				}
			}
			let data = null
			if (total_money > 0) {

				data = {
					stu_id: 0,
					total_money: total_money,
					bz: this.feeBz,
					remark: JSON.stringify(feeList)
				}




			}

			return data
		},
	}
}
</script>
